module.exports = __webpack_public_path__ + "static/media/header_logo.d072196b.png";